/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface OperationalGoldenLinkBackfillResponse
 */
export interface OperationalGoldenLinkBackfillResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    processedByEntityType?: { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof OperationalGoldenLinkBackfillResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the OperationalGoldenLinkBackfillResponse interface.
 */
export function instanceOfOperationalGoldenLinkBackfillResponse(value: object): value is OperationalGoldenLinkBackfillResponse {
    return true;
}

export function OperationalGoldenLinkBackfillResponseFromJSON(json: any): OperationalGoldenLinkBackfillResponse {
    return OperationalGoldenLinkBackfillResponseFromJSONTyped(json, false);
}

export function OperationalGoldenLinkBackfillResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationalGoldenLinkBackfillResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'processedByEntityType': json['processedByEntityType'] == null ? undefined : json['processedByEntityType'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function OperationalGoldenLinkBackfillResponseToJSON(json: any): OperationalGoldenLinkBackfillResponse {
    return OperationalGoldenLinkBackfillResponseToJSONTyped(json, false);
}

export function OperationalGoldenLinkBackfillResponseToJSONTyped(value?: OperationalGoldenLinkBackfillResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'tenantId': value['tenantId'],
        'processedByEntityType': value['processedByEntityType'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

